// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
	$(".blackout").hover(function () {
		$(".menu-responsive-wrap").removeClass("active");
		setTimeout(() => {
			var els = document.querySelectorAll(".showSubMenu, .show-mega");
			for (var i = 0; i < els.length; i++) {
				els[i].classList.remove("showSubMenu");
				els[i].classList.remove("show-mega");
			}
			$("header .chev_a a").removeClass("show-mega");
			$("header .chev_a a").removeClass("flip-arrow");
			$(".menu-responsive-wrap").removeClass("show");
			$(".blackout").removeClass("is-active");
			$("header").removeClass("dark-head");
		}, 300);
	});

	//mega_menu
	$(".mega_menu_toggle").click(function () {
		$(this).toggleClass("is-active");
		$(".mega-wrap").toggleClass("is-active");

		return false;
	});

	$(".menu-responsive .menu-item-has-children").click(function (e) {
		if ($(this).hasClass("is-active")) {
		} else {
			$(this).addClass("is-active");
			e.preventDefault();
		}
	});

	$(".mobile-nav .menu-item-has-children").append(
		'<span class="open-menu far fa-chevron-right"></span>'
	);

	//Level 1
	$(".open-menu").on("click", function () {
		var level1 = document.getElementsByClassName("level-1");
		if (level1.length > 0) {
			$(this).addClass("level-2-open");
			$(this).prev(".sub-menu").addClass("level-2");
			$(this).closest(".menu-item-has-children").addClass("level-2-hold");
			$(".navbar-toggler").addClass("hide-menu");
			$(".navbar-toggler").removeClass("open-mobile-menu");
			$(".back-menu").addClass("show-back");
			$(this).siblings().addClass("is-active");
		} else {
			$(this).addClass("level-1-open");
			$(this).prev(".sub-menu").addClass("level-1");
			$(this).closest(".menu-item-has-children").addClass("level-1-hold");
			$(".navbar-toggler").addClass("hide-menu");
			$(".back-menu").addClass("show-back");
			$(this).siblings().addClass("is-active");
		}
	});

	//Level 1 - Back
	$(".back-menu").on("click", function () {
		var level1 = document.getElementsByClassName("level-1");
		var level2 = document.getElementsByClassName("level-2");
		if (level2.length > 0) {
			$(".sub-menu").removeClass("level-2");
			$(".open-menu").removeClass("active-menu");
			$(".menu-item-has-children").removeClass("level-2-hold");
			$(".navbar-toggler").addClass("open-mobile-menu");
		} else if (level1.length > 0) {
			$(".sub-menu").removeClass("level-1");
			$(".menu-item-has-children").removeClass("level-1-hold");
			$(".navbar-toggler").removeClass("hide-menu");
			$(".navbar-toggler").addClass("open-mobile-menu");
			$(".back-menu").removeClass("show-back");
		}
	});

	// Trigger sub menu
	$(".nav__link").click(function (e) {
		e.preventDefault();

		$(this).siblings().addClass("is-active");
	});

	$(".blackout").hover(function () {
		$(".menu-responsive-wrap-search").removeClass("active");
		setTimeout(() => {
			var els = document.querySelectorAll(".showSubMenu, .show-mega");
			for (var i = 0; i < els.length; i++) {
				els[i].classList.remove("showSubMenu");
				els[i].classList.remove("show-mega");
			}
			$("header .chev_a a").removeClass("show-mega");
			$("header .chev_a a").removeClass("flip-arrow");
			$(".menu-responsive-wrap").removeClass("show");
			$(".blackout").removeClass("is-active");
			$("header").removeClass("dark-head");
		}, 400);
	});

	//Mobile Nav
	// OPEN MENU
	$(".open-mobile-menu").click(function () {
		$(this).toggleClass("active");
		$("body").toggleClass("menu-is-open"); // Always toggle on body

		setTimeout(function () {
			$(".menu-responsive-wrap-mobile").toggleClass("is-active");
			$(".blackout").toggleClass("is-active");
		}, 400);

		return false;
	});

	// CLOSE MENU
	$(".open-mobile-menu.active").click(function () {
		var $this = $(this);

		// Delay removing the class for 0.4 seconds (400ms)
		setTimeout(function () {
			$this.removeClass("active");
		}, 400);

		return false;
	});

	//mega-menu__wrapper
	$(".chev_a").hover(function () {
		$(".menu-responsive-wrap-search").removeClass("show-mega-search");
		$(".blackout-search").removeClass("is-active");
	});

	//Close Nav
	$(".close-menu").on("click", function () {
		$(".menu-responsive-wrap-mobile").removeClass("is-visible");
	});

	$(window).scroll(function () {
		var sc = $(window).scrollTop();
		if (sc > 100) {
			$("#navbar").addClass("sticky-nav");
		} else {
			$("#navbar").removeClass("sticky-nav");
		}
	});

	//Search
	$("#close-btn").click(function () {
		$("#search-overlay").fadeOut();
		$("#search-btn").show();
		$("body").removeClass("search_active");
	});
	$("#search-btn").click(function () {
		//$(this).hide();
		$("#search-overlay").fadeIn();
		$("body").addClass("search_active");
	});
});
